import { Component, OnInit, ViewChild } from '@angular/core';
import { RunService, Task } from 'src/app/core/http/run/run.service';
import { FormControl } from '@angular/forms';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';

import 'codemirror/mode/sql/sql';
import 'codemirror/mode/go/go';

import { LessonListService } from 'src/app/core/http/lessonList/lesson-list.service';
import { MatTableDataSource } from '@angular/material/table';
import { TaskListService } from 'src/app/core/http/taskList/task-list.service';
import { Subscription } from 'rxjs';
import { SchemaService, answer } from 'src/app/shared/services/schema/schema.service';
import { TitleAndCrumbServiceService } from 'src/app/shared/services/title/title-and-crumb-service.service';
import { MatPaginator } from '@angular/material/paginator';



@Component({
  selector: 'app-run',
  templateUrl: './run.component.html',
  styleUrls: ['./run.component.css']
})
export class RunComponent implements OnInit {
  mySchema:any = {}
  formData: FormData;
  NavEnd: Subscription;
  CodeSub: Subscription;
  correctly = 0;
  task: Task = {
    id: 0, 
    name: "Задание", 
    notepadmode: "go",
    information: "Описание",
    resulttype: "0"
  };
  TaskNav;
  course_id: string;
  task_id: string;
  displayedColumns = null;
  TableRows: MatTableDataSource<any>;
  responsBack:Array<answer>;

  query = new FormControl('');

  response: any;

  @ViewChild(MatPaginator, {static: false}) paginator: MatPaginator;
  
  constructor(private runServices: RunService, private TACServices:TitleAndCrumbServiceService, private schemaService: SchemaService,  private route: ActivatedRoute, private router: Router, private lessonService: LessonListService, private taskService: TaskListService) {
    this.NavEnd = this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.correctly = 0;
        this.response = [];
        this.mySchema = {};
        this.course_id = this.route.snapshot.paramMap.get("course");
        this.task_id = this.route.snapshot.paramMap.get("task");
        this.getFullTask();
        this.getTaskNav();
        this.query.setValue(localStorage.getItem('c'+this.course_id + '/' + this.task_id) || '');
      }
    })
  }
  reModel() {
    this.runCheck(JSON.stringify(this.responsBack));
  }
  ngOnInit() {
    this.saveCode();
  }
  runCheck(answer) {
    this.formData = new FormData();
    if (this.task.technology == 'form') {
      answer = JSON.stringify(this.schemaService.reModel(answer));
    }
    this.formData.append('query', answer);
    this.runServices.run(this.task_id, this.formData)
    .subscribe(resp => {
      this.response = resp;
      if (this.response.resulttype == 0) {
        this.TableRows = new MatTableDataSource<any>(this.response.resultcontent.tablerows);
        this.displayedColumns = this.response.resultcontent.tableheaders;
        setTimeout(() => this.TableRows.paginator = this.paginator);
      }
      this.correctly = this.checkAnswer;
    },
    (err) => {
      console.log(err)
    }
    );
  }

  getFullTask() {
    this.runServices.getTask(this.task_id)
    .subscribe(resp => {
      this.task = resp;
      this.TACServices.changeTitleAndCrumb(this.route, this.task.name);
      if (this.task.technology == 'form') {
        this.runServices.getFields(this.task_id)
        .subscribe(res => {
          this.createSchema(res);
        })
        
      }
    });
  }

  getTaskNav() {
    this.lessonService.GetTasksByLesson(this.task_id)
    .subscribe(res=>{
     this.TaskNav = res;
    })
  }

  get checkAnswer(): number {
    if (this.response.response == 'ok') return 1;
    else return 2;
  }

  

  createSchema(fields) {
    this.mySchema = this.schemaService.createSchema(fields);
  }
  
  saveCode() {
    this.CodeSub = this.query.valueChanges.subscribe(val => {
      if (this.query.value.length >= 10) localStorage.setItem('c'+this.course_id + '/' + this.task_id, this.query.value);
    });
  }


  ngOnDestroy() {
    this.NavEnd.unsubscribe();
    this.CodeSub.unsubscribe();
  }      

  CompletedTasks(tasks) {
    var result = tasks.filter(s => s.completed==1);
    return result.length
  }

  PrevTask(tasks) {
    var index = tasks.findIndex(x => x.id == this.task_id);
    var prevI = index - 1;
    if (prevI >= 0) {
      return tasks[prevI].id;
    } else {
      return false;
    }
  }
  NextTask(tasks) {
    var index = tasks.findIndex(x => x.id == this.task_id);
    var nextI = index + 1;
    if (tasks[nextI]) {
      return tasks[nextI].id;
    } else {
      return false;
    }
  }
  
}
